export default function (htmlObj) {
  return htmlObj?.childMarkdownRemark?.html || null
}
